import { observer } from 'mobx-react-lite'
import React from 'react'
import { SendSMSBlockActionEditContent } from 'widgets/Flow/blocks/SendSMS'
import { type SendSMSStore } from '../../store/SendSMSStore'

type IActionEditContentProps = {
  store: SendSMSStore
}
export const SendSMSActionEditContent = observer(({ store }: IActionEditContentProps) => {
  const { sendSMSBlockStore } = store

  return <SendSMSBlockActionEditContent store={sendSMSBlockStore} />
})
